import styled from "styled-components";

import { colors } from "../../../../../assets";
import { SectionContainer } from "../../clients-dashboard-style";

export const EiacFilesContainer = styled(SectionContainer)`
  table thead tr th {
    background-color: ${colors["msg-info"]};
    color: ${colors["TX-001-100"]};
  }

  .info-button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 50px;
  }
`;
